export type LabelKV = { name: string; value: string };
export const REQUIRED_LABELS = ['Domain'] as const;

export const computeRequiredMap = (labels: LabelKV[]) => {
  const map: Record<string, boolean> = {};
  for (const k of REQUIRED_LABELS) {
    const hits = labels.filter(l => l.name === k && l.value).length;
    map[k] = k === 'Domain' ? hits === 1 : hits > 0;
  }
  return map;
};

export const buildLabelsIndex = (businessData: any) => {
  const out: Record<string, { found: LabelKV[]; domainValue: string | null }> = {};
  if (!businessData?.releases) return out;
  for (const r of businessData.releases) {
    const found: LabelKV[] = Array.isArray(r.labels) ? r.labels : [];
    const domain = found.find((l) => l.name === 'Domain');
    out[r.name] = {
      found,
      domainValue: domain ? domain.value : null,
    };
  }
  return out;
};

export const hasAllRequired = (
  app: string,
  stored: Record<string, { requiredLabels?: Record<string, boolean> }>,
  runtime: Record<string, { found: LabelKV[] }>
) => {
  const m = stored[app]?.requiredLabels ?? computeRequiredMap(runtime[app]?.found ?? []);
  return REQUIRED_LABELS.every(k => !!m[k]);
};

export function getStoredLabelsInfo(
  finalServiceDeps: any[] = [],
  finalInfraDeps: any[] = [],
  labelsByApp: Record<string, { found: LabelKV[] }> = {}
) {
  const storedLabelsInfo: Record<string, { requiredLabels: Record<string, boolean>; found: LabelKV[] }> = {};

  for (const dep of [...finalServiceDeps, ...finalInfraDeps]) {
    const found = labelsByApp[dep.name]?.found ?? [];
    storedLabelsInfo[dep.name] = {
      requiredLabels: computeRequiredMap(found),
      found
    };
  }

  return storedLabelsInfo;
}
